var exports = {
  "EN": "ellipsisOverflow__n1Y7OI",
  "WK": "directionRtl__MrRljE",
  "CE": "directionLtr__jJBPsD",
};

module.exports = exports;
